import { takeLatest, put, call } from 'redux-saga/effects'
import { GET_TOKEN, GET_TOKEN_FAIL, GET_TOKEN_SUCCESS, GetTokenActionType } from 'dealer-reducers'
import apiCall from 'src/helpers/apiCall'
import { getDeviceId } from 'src/helpers/deviceId'
import { poolData } from 'src/helpers/userPool'

interface Redponse {
  sub: string
  access_token: string
  id_token: string
  refresh_token: string
  email: string
}

function* GetTokenFlow(action: GetTokenActionType): Generator<any, void, any> {
  try {
    const response: Redponse = yield call(apiCall, {
      endpoint: '/api/v2/profiles/get_token',
      method: 'POST',
      params: { code: action.payload.code }
    })
    const perfix = `CognitoIdentityServiceProvider.${poolData.ClientId}.${response.sub}`
    localStorage.setItem(`${perfix}.accessToken`, response.access_token)
    localStorage.setItem(`${perfix}.clockDrift`, '0')
    localStorage.setItem(`${perfix}.idToken`, response.id_token)
    localStorage.setItem(`${perfix}.refreshToken`, response.refresh_token)
    localStorage.setItem(`CognitoIdentityServiceProvider.${poolData.ClientId}.LastAuthUser`, response.sub)
    localStorage.setItem('dealer_email', response.email)
    getDeviceId()
    yield put(GET_TOKEN_SUCCESS())
    window.location.href = '/'
  } catch (error) {
    yield put(GET_TOKEN_FAIL())
  }
}

export default function* GetTokenSaga(): Generator<any, void, any> {
  yield takeLatest([GET_TOKEN], GetTokenFlow)
}
